import type { SVGProps } from 'react';

export const CSV = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'CSV'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <rect height="32" width="32" x="0" y="0" />
      <g transform="translate(1.000000, 0.000000)">
        <path
          d="M22,0.75 C22.8974627,0.75 23.7099627,1.11376864 24.298097,1.70190296 C24.8862314,2.29003728 25.25,3.10253728 25.25,4 L25.25,4 L25.25,18.25 L29.25,18.25 L29.25,27.7501405 L25.240475,27.7508918 C25.3209547,28.8219697 24.8809307,29.7928496 24.148192,30.4388709 C23.5754928,30.9437929 22.8234895,31.25 22,31.25 L22,31.25 L4,31.25 C3.10253728,31.25 2.29003728,30.8862314 1.70190296,30.298097 C1.11376864,29.7099627 0.75,28.8974627 0.75,28 L0.75,28 L0.75,4 C0.75,3.10253728 1.11376864,2.29003728 1.70190296,1.70190296 C2.29003728,1.11376864 3.10253728,0.75 4,0.75 L4,0.75 Z"
          stroke={props.fill}
          strokeWidth="1.5"
        />
        <rect
          height="9.5"
          stroke={props.fill}
          strokeWidth="1.5"
          width="23.5"
          x="5.75"
          y="18.25"
        />
        <g
          fill={props.fill}
          fillRule="nonzero"
          transform="translate(9.500000, 20.000000)"
        >
          <path d="M1.28571429,3 C1.28571429,1.89779006 2.06722689,1.0359116 3.13445378,1.0359116 C3.58823529,1.0359116 4.00840336,1.21823204 4.36134454,1.48342541 L4.94117647,0.563535912 C4.36134454,0.20718232 3.80672269,0 3.13445378,0 C1.40336134,0 0,1.30110497 0,3 C0,4.77348066 1.31932773,6 3.08403361,6 C3.80672269,6 4.48739496,5.77624309 5.05882353,5.34530387 L4.38655462,4.48342541 C4.02521008,4.79005525 3.57983193,4.9640884 3.13445378,4.9640884 C1.98319328,4.9640884 1.28571429,4.16022099 1.28571429,3 Z"></path>
          <path d="M9.19327731,1.53314917 L9.88235294,0.687845304 C9.28571429,0.240331492 8.68907563,0 7.93277311,0 C6.95798319,0 6.00840336,0.522099448 6.00840336,1.62430939 C6.00840336,2.73480663 6.86554622,3.06629834 7.6302521,3.3480663 C8.22689076,3.56353591 8.76470588,3.75414365 8.76470588,4.25138122 C8.76470588,4.76519337 8.30252101,4.98895028 7.83193277,4.98895028 C7.21848739,4.98895028 6.8487395,4.71546961 6.3697479,4.25966851 L5.57142857,5.03038674 C6.21008403,5.66022099 6.91596639,6 7.82352941,6 C8.8487395,6 10.0504202,5.46132597 10.0504202,4.20165746 C10.0504202,2.98342541 9.05042017,2.60220994 8.21848739,2.32044199 C7.76470588,2.16298343 7.21008403,2.03867403 7.21008403,1.59116022 C7.21008403,1.20994475 7.57142857,1.01104972 7.97478992,1.01104972 C8.42857143,1.01104972 8.86554622,1.25966851 9.19327731,1.53314917 Z" />
          <polygon points="16 0.0994475138 14.6722689 0.0994475138 13.210084 4.08563536 13.2016807 4.08563536 11.8067227 0.0994475138 10.4117647 0.0994475138 12.6218487 5.90055249 13.605042 5.90055249"></polygon>
        </g>
        <line
          stroke={props.fill}
          strokeLinecap="round"
          strokeWidth="1.5"
          x1="6"
          x2="20"
          y1="6"
          y2="6"
        />
        <line
          stroke={props.fill}
          strokeLinecap="round"
          strokeWidth="1.5"
          x1="6"
          x2="20"
          y1="10"
          y2="10"
        />
        <line
          stroke={props.fill}
          strokeLinecap="round"
          strokeWidth="1.5"
          x1="6"
          x2="20"
          y1="14"
          y2="14"
        />
      </g>
    </g>
  </svg>
);
